import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "system-anomalies",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Surface operational anomalies requiring attention.",
    domain: "anomalies",
    visual: "Table",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "table", skeleton: "table" },
  defaultLayoutClassName: "col-span-12",
};
